import React, { useEffect } from "react";
import SearchBox from './SearchBox.jsx';
import { translate } from "../../../utility/strings.js";
import InternationalDealers from "./InternationalDealers.jsx";
import SearchHomeIcon from './assets/SearchHomeIcon.svg';

const Search = () => {

  return (
    <div className="ft_dealer-locator__search-container">
      <div className="ft_dealer-locator__search">
        <div className="search-home_icon mb-6">
          <SearchHomeIcon />
        </div>
        <h1 className="ft_dealer-locator__search__title h2 text-white mb-[10px]">{translate("dealer_locator.heading", "Find a Dealer")}</h1>
        <h2 className="ft_dealer-locator__search__subtitle body text-white mb-5">{translate("dealer_locator.subheading", "USA and Canada")}</h2>
        <div className="ft_dealer-locator__search__box mb-6">
          <SearchBox />
        </div>
        <InternationalDealers links={window.dealer_locator?.links} />
      </div>
    </div>
  );

}

export default Search;
